
import React from "react";
import { ResponsiveContainer, Treemap, Tooltip } from "recharts";

interface TreemapComponentProps {
  data: Array<{name: string, value: number, color: string}>;
}

// Custom component for Treemap labels to ensure visibility
const CustomTreemapContent = (props: any) => {
  const { depth, x, y, width, height, index, name, value, color } = props;
  
  // Only render text if the rectangle is large enough
  if (width < 30 || height < 30) return null;
  
  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        style={{ fill: color, stroke: '#fff', strokeWidth: 3 }}
      />
      <text
        x={x + width / 2}
        y={y + height / 2 - 8}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={12}
        fontWeight="bold"
        fill="#000"
      >
        {name}
      </text>
      <text
        x={x + width / 2}
        y={y + height / 2 + 8}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={10}
        fill="#000"
      >
        ${value.toLocaleString()}
      </text>
    </g>
  );
};

export const TreemapComponent: React.FC<TreemapComponentProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <Treemap 
        data={data} 
        dataKey="value" 
        content={<CustomTreemapContent />}
      >
      </Treemap>
    </ResponsiveContainer>
  );
};
